import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import RefreshIcon from "@material-ui/icons/Refresh";
import axios from "axios";
import { ModalError, Page, PrimaryButton } from "components";
import { HeaderTitle } from "layouts";
import moment from "moment";
import { useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors } from "utils";
import UpdateModal from "./UpdateModal";

const useStyles = makeStyles(() => ({
  title: {
    fontWeight: 700,
  },
  card: {
    borderRadius: "10px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.05)",
  },
  label: {
    marginBottom: "8px",
  },
  value: {
    fontWeight: 600,
  },
  divider: {
    margin: "16px 0",
  },
  description: {
    whiteSpace: "pre-line",
  },
}));

const AppManagement = () => {
  const classes = globalStyles();
  const localClasses = useStyles();
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };

  const [loading, setLoading] = useState(false);
  const [appData, setAppData] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const fetchAppData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${hardBaseUrl}/app/latest`, {
        headers,
      });
      const { data } = response.data;
      setAppData(data);
    } catch (error) {
      ModalError(getErrors(error.response));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAppData();
  }, []);

  const breadcrumbData = [
    { label: "Home", link: "/admin/dashboard" },
    { label: "APP Management", active: true },
  ];

  return (
    <Page className={classes.root} title="APP Management">
      <Container maxWidth={false}>
        <HeaderTitle title="APP Management" breadcrumbData={breadcrumbData} />

        <Box
          mt={3}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h4" className={localClasses.title}>
            Current APP
          </Typography>
          <PrimaryButton
            label="Update App"
            startIcon={<RefreshIcon />}
            onClick={() => setModalOpen(true)}
          />
        </Box>

        <Box mt={2}>
          <Card variant="outlined" className={localClasses.card}>
            <CardContent>
              {loading ? (
                <Typography>Loading app details...</Typography>
              ) : (
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4}>
                    <Typography
                      variant="subtitle2"
                      color="textSecondary"
                      className={localClasses.label}
                    >
                      Version :
                    </Typography>
                    <Typography variant="body1" className={localClasses.value}>
                      {appData?.version || "N/A"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Typography
                      variant="subtitle2"
                      color="textSecondary"
                      className={localClasses.label}
                    >
                      Release Date :
                    </Typography>
                    <Typography variant="body1" className={localClasses.value}>
                      {appData?.release_date
                        ? moment(appData.release_date).format("DD-MMM-YYYY")
                        : "N/A"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Divider className={localClasses.divider} />
                    <Typography
                      variant="subtitle2"
                      color="textSecondary"
                      className={localClasses.label}
                    >
                      Description :
                    </Typography>
                    <Typography
                      variant="body1"
                      className={localClasses.description}
                    >
                      {appData?.description || "No description provided."}
                    </Typography>
                  </Grid>
                </Grid>
              )}
            </CardContent>
          </Card>
        </Box>
      </Container>

      {modalOpen && (
        <UpdateModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          onSuccess={fetchAppData}
        />
      )}
    </Page>
  );
};

export default AppManagement;
